import { render, staticRenderFns } from "./fAlert.template?vue&type=template&id=d9c3f59a&scoped=true&lang=pug&"
import script from "./fAlert.client?vue&type=script&lang=ts&"
export * from "./fAlert.client?vue&type=script&lang=ts&"
import style0 from "./fAlert.style?vue&type=style&index=0&id=d9c3f59a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c3f59a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/flypaper/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9c3f59a')) {
      api.createRecord('d9c3f59a', component.options)
    } else {
      api.reload('d9c3f59a', component.options)
    }
    module.hot.accept("./fAlert.template?vue&type=template&id=d9c3f59a&scoped=true&lang=pug&", function () {
      api.rerender('d9c3f59a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/widgets/fAlert/fAlert.component.vue"
export default component.exports